// extracted by css-extract-rspack-plugin
export default {"Dashboard":"sputnik__Dashboard__IgBWG","dashboard":"sputnik__Dashboard__IgBWG"};